import {
   ServiceProvidingLocation,
   ServiceProvidingLocationForCurrentPracticeQuery,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { UseCqrsQueryResult, useCqrsSearch } from '@dreryk/command-query-react-common';
import { Slot } from '@dreryk/watermelon';

export const useServiceProvidingLocationForCurrentPracticeQuery = (
   withRemovedLocations?: boolean
): UseCqrsQueryResult<ServiceProvidingLocation[]> => {
   return useCqrsSearch(
      () => {
         const query = new ServiceProvidingLocationForCurrentPracticeQuery();
         query.removed = Slot.emptyIfNull(withRemovedLocations ? null : false);
         return query;
      },
      undefined,
      {
         cacheTime: 'short',
      }
   );
};
